import { render } from "./rehearse.vue?vue&type=template&id=05aa5487&scoped=true"
import script from "./rehearse.vue?vue&type=script&lang=js"
export * from "./rehearse.vue?vue&type=script&lang=js"

import "./rehearse.vue?vue&type=style&index=0&id=05aa5487&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aa5487"]])

export default __exports__